import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state = {
  groupByAttributeKey: null,
  columns: {},
  uiFlags: {
    isFetchingColumns: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
